import { throttle } from '@tanstack/react-pacer';

import { IViewerStoreInjector, appContainer } from '../../../inversify.config';
import { TYPES } from '../../../inversify.types';
import { arrowLeftShortcut } from './arrow-left';

const THROTTLED_WAIT_TIME_IN_MS = 1000;

export const wheelUpShortcut = {
  key: new Set(['WheelUp']),
  callBackFunction: throttle(
    () => {
      const { pageMode } = appContainer.get<IViewerStoreInjector>(TYPES.Store.Viewer).getState();
      const isSinglePageMode = pageMode === 'single';

      if (!isSinglePageMode) return;

      arrowLeftShortcut.callBackFunction();
    },
    { wait: THROTTLED_WAIT_TIME_IN_MS, trailing: false }
  ),
};
